import React from 'react'
import { Box, Typography } from '@mui/material'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import { useTranslation } from 'react-i18next'

const PointTabPlaceholder = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        color: '#7b809a'
      }}
    >
      <PointOfSaleIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
      <Typography variant="h6" gutterBottom>
        {t('POS / Loyalty Point Settings')}
      </Typography>
      <Typography variant="body2">
        {t('Coming Soon')}
      </Typography>
    </Box>
  )
}

export default PointTabPlaceholder
